/**
 * Verknüpft WPForms-Fehlermeldungen zuverlässig mit ihrem Feld
 * (aria-invalid, aria-describedby, aria-errormessage), damit ein
 * Screenreader beim Fokus auf ein ungültiges Feld auch hört, warum.
 *
 * WPForms (jQuery Validate) verdrahtet das nur teilweise:
 * - Datum/Uhrzeit teilen sich einen Fehler-Container, das zweite Feld
 *   verweist dann auf eine Meldung, die nie eingefügt wurde.
 * - Checkbox-Gruppen bekommen die Meldung als "<name>-error", aber
 *   aria-errormessage zeigt auf "<id>-error" - eine ID, die es nicht gibt.
 *   (Die IDs von WPForms bleiben unverändert, jQuery Validate findet seine
 *   Meldungen darüber wieder.)
 * - Beim Korrigieren entfernt WPForms die <em>, die Verweise bleiben stehen.
 * - Serverseitig gerenderte Fehler (Seite neu geladen) sind nicht verknüpft.
 *
 * Statt jeden dieser Pfade einzeln zu patchen, wird nach jeder Änderung am
 * Formular der Zustand aus dem DOM abgeleitet: Feld mit Fehlerklasse +
 * sichtbare Meldung im selben .wpforms-field => verknüpfen, sonst aufräumen.
 */
(function () {
    const FIELD_SELECTOR = 'input:not([type="hidden"]):not([type="submit"]), textarea, select';
    const MESSAGE_SELECTOR = 'em.wpforms-error, label.wpforms-error';

    function lhm_getIdList(field, attribute) {
        return (field.getAttribute(attribute) || '').split(/\s+/).filter(Boolean);
    }

    function lhm_isVisibleMessage(message) {
        return message.textContent.trim() !== '' && message.getClientRects().length > 0;
    }

    // Eigene Meldung ("<id>-error" bzw. "<name>-error" bei Gruppen), sonst die
    // einzige Meldung im Block - z.B. die geteilte bei Datum/Uhrzeit
    function lhm_findMessage(field, container) {
        const messages = Array.from(container.querySelectorAll(MESSAGE_SELECTOR))
            .filter((message) => lhm_isVisibleMessage(message));

        const own = messages.find((message) => message.id === `${field.id}-error` || message.id === `${field.name}-error`);
        if (own) {
            return own;
        }

        const block = field.closest('.wpforms-field-row-block') || container;
        const blockMessages = messages.filter((message) => block.contains(message));
        return blockMessages.length === 1 ? blockMessages[0] : null;
    }

    function lhm_isErrorId(id) {
        return /-error$/.test(id);
    }

    function lhm_syncField(field) {
        const container = field.closest('.wpforms-field');
        if (!container) {
            return;
        }

        // Bei Checkbox-/Radio-Gruppen markiert WPForms alle Optionen gleich
        const hasErrorClass = field.classList.contains('wpforms-error');
        const message = hasErrorClass ? lhm_findMessage(field, container) : null;

        // Verweise auf alte Meldungen entfernen, Beschreibungen (Hinweistexte) behalten
        const describedBy = lhm_getIdList(field, 'aria-describedby')
            .filter((id) => !lhm_isErrorId(id) || (message && id === message.id));

        if (message) {
            const messageId = message.id || `${field.id}-error`;
            message.id = messageId;
            if (!describedBy.includes(messageId)) {
                describedBy.push(messageId);
            }
            field.setAttribute('aria-invalid', 'true');
            field.setAttribute('aria-errormessage', messageId);
        } else {
            field.removeAttribute('aria-errormessage');
            if (field.getAttribute('aria-invalid') === 'true') {
                field.setAttribute('aria-invalid', 'false');
            }
        }

        if (describedBy.length > 0) {
            field.setAttribute('aria-describedby', describedBy.join(' '));
        } else {
            field.removeAttribute('aria-describedby');
        }
    }

    function lhm_syncForm(form) {
        form.querySelectorAll(FIELD_SELECTOR).forEach(lhm_syncField);
    }

    function lhm_initForm(form) {
        let scheduled = false;

        // Mehrere Mutationen (Klasse + <em>) pro Validierung => einmal pro Frame syncen
        const observer = new MutationObserver(() => {
            if (scheduled) {
                return;
            }
            scheduled = true;
            requestAnimationFrame(() => {
                scheduled = false;
                lhm_syncForm(form);
            });
        });

        // Nur Klassen und Kind-Elemente beobachten - die hier gesetzten
        // aria-Attribute lösen so keine weitere Runde aus
        observer.observe(form, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['class', 'style'],
        });

        lhm_syncForm(form);
    }

    function lhm_initWpformsErrorAria() {
        document.querySelectorAll('.layoutformulare form.wpforms-form').forEach(lhm_initForm);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', lhm_initWpformsErrorAria);
    } else {
        lhm_initWpformsErrorAria();
    }
})();
